import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @calm/react-intl/missing-formatted-message */ import Restart16 from '@carbon/icons-react/es/restart/16';
import Intercom, { show } from '@intercom/messenger-js-sdk';
import { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { ReactComponent as ExclamationTriangle } from 'assets/svgs/exclamation-triangle.svg';
import { EmptyState, EmptyStateContainer } from 'components/atoms/empty-state';
import { Button } from 'components/facade/button';
import { BodyShort01 } from 'components/styles';
import { INTERCOM_APP_ID } from 'config/environment';
import { useTranslate } from 'hooks/use-translation';
import { logger } from 'services';
const Description = styled.div`
  ${BodyShort01};
`;
const RefreshButton = styled(Button)`
  width: fit-content;
`;
const LinkButton = styled(Button)`
  padding: 0 var(--spacing-01) !important;
`;
var Status = /*#__PURE__*/ function(Status) {
    Status["Unchecked"] = "Unchecked";
    Status["NotRequired"] = "NotRequired";
    Status["Loaded"] = "Loaded";
    Status["Initialized"] = "Initialized";
    return Status;
}(Status || {});
let status = "Unchecked";
const initIntercomChat = ()=>{
    if (status !== "Loaded") {
        return;
    }
    status = "Initialized";
    Intercom({
        app_id: INTERCOM_APP_ID !== null && INTERCOM_APP_ID !== void 0 ? INTERCOM_APP_ID : '',
        alignment: 'left',
        horizontal_padding: 70,
        vertical_padding: 35,
        hide_default_launcher: true
    });
};
const initialize = ()=>{
    if (status !== "Unchecked") {
        return;
    }
    status = "Loaded";
    initIntercomChat();
};
// The crash screen self-reports so "sessions where a user saw this screen" is
// directly queryable (DD + LR) instead of inferred from boundary signatures.
let crashScreenReported = false;
const reportCrashScreenShown = ()=>{
    if (crashScreenReported) {
        return;
    }
    crashScreenReported = true;
    try {
        logger.error('crash-screen-shown', {
            error: undefined,
            url: window.location.href
        });
        import(/* webpackChunkName: "logrocket" */ 'logrocket').then(({ default: LogRocket })=>{
            LogRocket.track('crash-screen-shown', {
                url: window.location.href
            });
        }).catch(()=>{});
    } catch (unused) {
    // Telemetry must never break the crash screen itself.
    }
};
export const AppCrashIntercom = ()=>{
    const translate = useTranslate();
    const refreshPage = useCallback(()=>{
        window.location.reload();
    }, []);
    const openIntercomChat = useCallback(()=>{
        show();
    }, []);
    useEffect(()=>{
        reportCrashScreenShown();
        if (status === "Unchecked") {
            initialize();
            status = "NotRequired";
        }
    }, []);
    return /*#__PURE__*/ _jsx(EmptyStateContainer, {
        $transparent: true,
        children: /*#__PURE__*/ _jsx(EmptyState, {
            image: /*#__PURE__*/ _jsx(ExclamationTriangle, {}),
            title: translate('document.open.version.failure.title'),
            message: translate('document.open.version.failure.message.text'),
            primaryCTA: /*#__PURE__*/ _jsx(RefreshButton, {
                type: "primary",
                onClick: refreshPage,
                iconPlacement: "right",
                icon: /*#__PURE__*/ _jsx(Restart16, {}),
                children: "Refresh"
            }),
            secondaryCTA: /*#__PURE__*/ _jsxs(Description, {
                children: [
                    "If the issue still persists",
                    /*#__PURE__*/ _jsx(LinkButton, {
                        type: "link",
                        onClick: openIntercomChat,
                        children: "please reach out to us."
                    })
                ]
            })
        })
    });
};
